import tranquilo from "../../../../assets/img/tranquilo.png";
import unico from "../../../../assets/img/unico.png";
import familiar from "../../../../assets/img/familia.png";
//import elegante from "../../../../assets/img/elegante.png";
//import central from "../../../../assets/img/central.png";
import espacioso from "../../../../assets/img/espacioso.png";

const Descripcion = ({ form, setForm }: any) => {
  const descripciones = [
    {
      name: "Accesible",
      icon: familiar,
    },
    {
      name: "Familiar",
      icon: familiar,
    },
    {
      name: "Tranquilo",
      icon: tranquilo,
    },
    {
      name: "Extensa",
      icon: espacioso,
    },
    {
      name: "Exclusiva",
      icon: unico,
    },
    {
      name: "Organizada",
      icon: espacioso,
    },
  ];

  const onClick = (e: any, value: string) => {
    switch (e.target.name) {
      case "description":
        {
          // let input = form;
          let descriptions = form.DESCRIPTION_EXCURSION;
          const description = {
            id: "",
            //--'Tranquilo', 'Único', 'Familiar', 'Elegante', 'Central', 'Espacioso'--
            name: value,
            excursion_id: "",
            created_at: "",
          };

          if (
            form.DESCRIPTION_EXCURSION.filter(
              (i: { name: string }) => i.name == value
            ).length > 0
          ) {
            descriptions = form.DESCRIPTION_EXCURSION.filter(
              (i: { name: string }) => i.name != value
            );
          } else {
            descriptions.push(description);
          }

          setForm({
            ...form,
            DESCRIPTION_EXCURSION: descriptions,
          });
        }
        break;
      default:
        break;
    }
  };

  const onChange = (e: any) => {
    switch (e.target.name) {
      case "description_long":
      case "description":
      case "title":
        {
          setForm({
            ...form,
            [e.target.name]: e.target.value,
          });
        }
        break;
      default:
        break;
    }
  };

  return (
    <div className="grid lg:grid-cols-1 gap-10 py-5 px-5">
      <div>
        <span className="font-bold text-black mb-2 block">
          A continuación, describamos tu excursión
        </span>
        <span>
          Elegí hasta 2 aspectos destacados. Los vamos a usar para comenzar tu
          descripción.
        </span>
        <div className="grid md:grid-cols-2 gap-5 mb-5">
          {descripciones.map((t) => {
            if (
              form.DESCRIPTION_EXCURSION.filter(
                (i: { name: string }) => i.name == t.name
              ).length > 0
            ) {
              return (
                <label
                  className="inline-block border p-3 m-1 cursor-pointer text-black  opacity-1 border-black"
                  style={{ borderRadius: "20px" }}
                >
                  <span className="flex items-center">
                    <img src={t.icon} width={20} className="me-2" alt="" />
                    {t.name}
                  </span>
                  <button
                    className="hidden"
                    name="description"
                    onClick={(e) => onClick(e, t.name)}
                  ></button>
                </label>
              );
            }

            return (
              <label
                className="inline-block border p-3 m-1 cursor-pointer text-black  opacity-1 border"
                style={{ borderRadius: "20px" }}
              >
                <span className="flex items-center">
                  <img src={t.icon} width={20} className="me-2" alt="" />
                  {t.name}
                </span>
                <button
                  className="hidden"
                  name="description"
                  onClick={(event) => onClick(event, t.name)}
                ></button>
              </label>
            );
          })}
        </div>

        <div className="mb-4">
          <span className="font-bold text-black block">
            Ahora, ponele título a tu excursión
          </span>
          <span className="block mb-2">
            Los títulos cortos funcionan mejor. No te preocupes, podés
            modificarlo más adelante.
          </span>
          <input
            className="py-3 w-full border rounded-xl"
            type="text"
            name="title"
            value={form.title}
            onChange={(e) => onChange(e)}
          />
          <span className="block font-bold">{form.title.length}/32</span>
        </div>

        <div className="mb-4">
          <span className="font-bold text-black  block">
            Describete como anfitrión
          </span>
          <span className="block mb-2">
            Cuentanos quien eres y que hace de tu espacio un lugar especial.
          </span>
          <input
            className="py-3 w-full border rounded-xl"
            type="text"
            name="description"
            value={form.description}
            onChange={(e) => onChange(e)}
          />
          <span className="block font-bold">{form.description.length}/32</span>
        </div>

         <div className="mb-4">
          <span className="font-bold text-black block">
            Descripcion larga
          </span>
          <span className="block mb-2">
            Cuenta con mas detalles que hace de tu espacio un lugar especial.
          </span>
          <textarea
            className="py-3 w-full border rounded-xl"
            name="description_long"
            value={form.description_long}
            onChange={(e) => onChange(e)}
          />
          <span className="block font-bold">{form.description_long.length}/700</span>
        </div>
      </div>
      <div></div>
    </div>
  );
};

export default Descripcion;
